const {h, render, Component} = require('preact');
const GrouponValidate = require('../../../../../groupon/frontend/validate');

class EmailAdressInputView extends Component {
  constructor(props) {
    super(props);
    this.isInputCompulsory = true;
    this.validateEmailAddress = this.validateEmailAddress.bind(this);
  }

  readInput() {
    return document.getElementById("v2-email-input").value.trim();
  }

  isInputGiven() {
    return document.getElementById("v2-email-input").value.trim().length > 0;
  }

  isInputValid() {
    return (this.validateDescription() == true)
  }

  validateEmailAddress() {
    var isValid = false;
    isValid = (this.isInputCompulsory &&  this.isInputGiven() && this.isInputValid())

    this.props.changeEmailAddressBoxState(this.readInput(), isValid);
  }

  validateDescription() {
    return GrouponValidate.email(this.readInput())
  }

  focusFormInput() {
    var emailAddressView = document.getElementById("email-address-view");
    emailAddressView.classList.add('focused');
    if (document.getElementById("v2-email-input").value.trim().length > 0) {
        emailAddressView.classList.add('filled');
    }
  }

  focusoutFormInput() {
    var emailAddressView = document.getElementById("email-address-view");
    emailAddressView.classList.remove('focused');
    if (document.getElementById("v2-email-input").value.trim().length > 0) {
      emailAddressView.classList.add('filled')
    }
    else {
      emailAddressView.classList.remove('filled')
    }
  }

  componentDidMount() {
    this.validateEmailAddress();
    var emailAdressBox = document.getElementById("email-address-view");
    emailAdressBox.addEventListener("focusin", this.focusFormInput)
    emailAdressBox.addEventListener("focusout", this.focusoutFormInput)
    emailAdressBox.addEventListener("keyup", this.validateEmailAddress)
  }

  render() {
    var isGuestCheckoutFlow = !!this.props.guestEmail
    var filled = false
    var userEmail = ''
    var classes = "gig-field inputField email-input"
    if(isGuestCheckoutFlow) {
      filled = true
      userEmail = this.props.guestEmail
      classes = "gig-field inputField email-input filled"
    }
    let attributes = {
      class:"inputField email_input call-back-inputs call-back-email-input",
      size:"40" ,
      maxlength:"250", 
      type:"email",
      id:"v2-email-input",
      disabled: isGuestCheckoutFlow ,
      "data-bhw":"call-me-back-option-email" ,
      "aria-label":"Email" ,
      address:"",
      ...(isGuestCheckoutFlow && {value: userEmail}),
      "data-bhw-path":"call-me-back-option-email" 

    }
    return (
      <div class="form-v2-1">
        <div class = {classes} id="email-address-view" >
          <label for = "v2-email-input"> {I18n.translate('js.modules.web_2018.emaillabel')}
            <span class="error-message validateEmailInput invalid-input call-back-option-error initially-hidden"
            style="display: none;">
                {I18n.translate('js.modules.support.invalidemail')}
            </span>
          </label>
           <input {...attributes} />
        </div>
        { this.props.helpText && <span class="form-field-help">{this.props.helpText}</span> }
      </div>
    )
  }
}

module.exports = EmailAdressInputView
